const STATE = {
  organizationId: null,
  collectionIndex: 0
}

export default STATE
